var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-dataset"},[(_vm.$slots.icon)?_c('div',{staticClass:"empty-dataset__icon"},[_vm._t("icon")],2):_vm._e(),_c('h4',{staticClass:"empty-dataset__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"empty-dataset__content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }